// App.js

import React, { Suspense, } from "react";
import { useSelector } from "react-redux";
import { Routes, Route, Navigate, BrowserRouter } from "react-router-dom";

import PrivateLayout from "layouts/private";
import PublicLayout from "layouts/publice";
import PrivateRoutes from "routes/private";
import PublicRoutes from "routes/public";
import PrivateRoutesTrial from "routes/trial/private";
import PublicRoutesTrial from "routes/trial/public";

import "styles/utility.css";
import { pathApp } from "services/utiles";
import { URLCheck } from "services/utiles";

function App() {
  const { isLoading } = useSelector((state) => state.session);
  const path = window.location.pathname.slice(0, 12) === '/app-testing' ? '/app-testing' : '/'

  return (
    <BrowserRouter basename={'/app'}>
      <Suspense fallback={<div>Loading...</div>}>
        {
          <Routes>
            <Route path="/" element={<PublicLayout />}>
              <Route path="/" element={<Navigate to={`/gift-login`} />} />
              {PublicRoutes.map((route, i) => (
                <Route
                  key={i}
                  path={route.path}
                  element={<route.component />}
                />
              ))}
              <Route path="*" element={<Navigate to={`/gift-login`} />} />
            </Route>

            {/* Private Routes */}
            <Route
              path="/"
              element={
                !isLoading ? <Navigate to={`/gift-login`} /> : <PrivateLayout />
              }
            >
              <Route path="/" index element={<Navigate to={`/gift-login`} />} />
              {PrivateRoutes.map((route, i) => (
                <Route
                  key={i}
                  path={route.path}
                  element={<route.component />}
                />
              ))}
              <Route path="*" element={<Navigate to={`/gift-login`} />} />
            </Route>


            <Route path="/" element={<PublicLayout />}>
              <Route path="/" element={<Navigate to={`/trial-login`} />} />
              {PublicRoutesTrial.map((route, i) => (
                <Route
                  key={i}
                  path={route.path}
                  element={<route.component />}
                />
              ))}
              <Route path="*" element={<Navigate to={`/trial-login`} />} />
            </Route>

            {/* Private Routes */}
            <Route
              path="/"
              element={
                !isLoading ? <Navigate to={`/trial-login`} /> : <PrivateLayout />
              }
            >
              <Route path="/" index element={<Navigate to={`/trial-login`} />} />
              {PrivateRoutesTrial.map((route, i) => (
                <Route
                  key={i}
                  path={route.path}
                  element={<route.component />}
                />
              ))}
              <Route path="*" element={<Navigate to={`/trial-login`} />} />
            </Route>
          </Routes>
        }
      </Suspense>
    </BrowserRouter>
  );
}

export default App;
